"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TABS = exports.DEFAULT_MAX_FILE_SIZE_MB = exports.DEFAULT_FILE_TYPES = exports.PUBLIC_KEY = exports.ACCEPT_TYPE_TO_MIME_TYPE = exports.UploadCareTabTypes = exports.UploadCareAcceptTypes = void 0;

var _environment = _interopRequireWildcard(require("../util/environment"));

var _ACCEPT_TYPE_TO_MIME_;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Partial list of types of files we can upload.  If you add to this list, you must, must
 * update the accept type to mime type mapping.
 *
 * This is incomplete: you can basically throw anything at the uploader.
 *
 * Poosible values:
 * - A valid case-insensitive filename extension, starting with a period (".") character. For example: .jpg, .pdf, or .doc.
 * - A valid MIME type string, with no extensions.
 * - The string audio/* meaning "any audio file".
 * - The string video/* meaning "any video file".
 * - The string image/* meaning "any image file".
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers
 * @see https://uploadcare.com/docs/uploads/file-uploader-options/#option-input-accept-types
 */
var UploadCareAcceptTypes;
/**
 * Supported sources for uploading files to upload care
 *
 * @see https://uploadcare.com/docs/uploads/file-uploader/#upload-source-list
 */

exports.UploadCareAcceptTypes = UploadCareAcceptTypes;

(function (UploadCareAcceptTypes) {
  UploadCareAcceptTypes["PDF_FILES"] = ".pdf";
  UploadCareAcceptTypes["JPEG_FILES"] = ".jpeg,.jpg,.jfif,.pjpeg,.pjp";
  UploadCareAcceptTypes["PNG_FILES"] = ".png";
})(UploadCareAcceptTypes || (exports.UploadCareAcceptTypes = UploadCareAcceptTypes = {}));

var UploadCareTabTypes;
exports.UploadCareTabTypes = UploadCareTabTypes;

(function (UploadCareTabTypes) {
  UploadCareTabTypes["BOX"] = "box";
  UploadCareTabTypes["CAMERA"] = "camera";
  UploadCareTabTypes["DROPBOX"] = "dropbox";
  UploadCareTabTypes["EVERNOTE"] = "evernote";
  UploadCareTabTypes["FACEBOOK"] = "facebook";
  UploadCareTabTypes["FILE"] = "file";
  UploadCareTabTypes["FLICKR"] = "flickr";
  UploadCareTabTypes["GOOGLE_DRIVE"] = "gdrive";
  UploadCareTabTypes["GOOGLE_PHOTOS"] = "gphotos";
  UploadCareTabTypes["HUDDLE"] = "huddle";
  UploadCareTabTypes["INSTAGRAM"] = "instagram";
  UploadCareTabTypes["ONE_DRIVE"] = "onedrive";
  UploadCareTabTypes["PREVIEW"] = "preview";
  UploadCareTabTypes["URL"] = "url";
  UploadCareTabTypes["VK"] = "vk";
  UploadCareTabTypes["RECENT"] = "recent";
})(UploadCareTabTypes || (exports.UploadCareTabTypes = UploadCareTabTypes = {}));

var ACCEPT_TYPE_TO_MIME_TYPE = (_ACCEPT_TYPE_TO_MIME_ = {}, _defineProperty(_ACCEPT_TYPE_TO_MIME_, UploadCareAcceptTypes.PDF_FILES, ['application/pdf']), _defineProperty(_ACCEPT_TYPE_TO_MIME_, UploadCareAcceptTypes.JPEG_FILES, ['image/jpeg']), _defineProperty(_ACCEPT_TYPE_TO_MIME_, UploadCareAcceptTypes.PNG_FILES, ['image/png']), _ACCEPT_TYPE_TO_MIME_);
/**
 * Key for uploading to upload care.
 */

exports.ACCEPT_TYPE_TO_MIME_TYPE = ACCEPT_TYPE_TO_MIME_TYPE;
var PUBLIC_KEY = (0, _environment.default)() === _environment.EnvironmentTypes.PRODUCTION ? 'bed481ea2bef6baf44de' : 'debf625b3ed8063e511f';
/**
 * Default file types to accept if not configured
 * NOTE: marketplace includes UploadCareAcceptTypes.PDF_FILES
 * */

exports.PUBLIC_KEY = PUBLIC_KEY;
var DEFAULT_FILE_TYPES = [UploadCareAcceptTypes.JPEG_FILES, UploadCareAcceptTypes.PNG_FILES];
exports.DEFAULT_FILE_TYPES = DEFAULT_FILE_TYPES;
var DEFAULT_MAX_FILE_SIZE_MB = 10;
/**
 * Default sources for the uploader if not configured.
 * NOTE: marketplace only includes UploadCareTabTypes.FILE
 */

exports.DEFAULT_MAX_FILE_SIZE_MB = DEFAULT_MAX_FILE_SIZE_MB;
var DEFAULT_TABS = [UploadCareTabTypes.FILE, UploadCareTabTypes.GOOGLE_PHOTOS, UploadCareTabTypes.DROPBOX];
exports.DEFAULT_TABS = DEFAULT_TABS;